import { CodebookModel } from 'app/shared/model/shared.model';

export interface CaseRequestInfoModel {
  requestName: string;
  requestFileNumber: string;
  requestAdmissionDate: Date;
  workStartDate: Date;
  requestAmendment: CodebookModel[];
  requestCompletionDate: Date;
  numberOfDaysToSolve: CodebookModel[];
  solutionDeadlineDate: Date;
}

export const caseRequestInfoInitial = {
  requestName: '',
  requestFileNumber: '',
  requestAdmissionDate: null,
  workStartDate: null,
  requestAmendment: [],
  requestCompletionDate: null,
  numberOfDaysToSolve: [],
  solutionDeadlineDate: null
}
